export function getInfiniteQueryCurrentDataLength(data?: any) {
    return (
        data?.pages.reduce((counter: number, page: any) => {
            return counter + page.results.length;
        }, 0) || 0
    );
}
